<div class="mb-3">
    <h3>{{ 'SETTINGS.TITLE' | translate }}</h3>
    <p class="text-muted">{{ 'SETTINGS.SUBTITLE' | translate }}</p>
</div>

<div class="row">
    <!-- Configurações Gerais -->
    <div class="col-md-6 mb-3">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <i class="ti ti-settings me-2"></i>
                    {{ 'SETTINGS.GENERAL.TITLE' | translate }}
                </h5>
            </div>
            <div class="card-body">
                <!-- Idioma -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.GENERAL.LANGUAGE' | translate }}</label>
                    <select class="form-select">
                        <option value="pt-BR" selected>Português (Brasil)</option>
                        <option value="en">English (US)</option>
                    </select>
                    <small class="text-muted">{{ 'SETTINGS.GENERAL.LANGUAGE_HINT' | translate }}</small>
                </div>

                <!-- Tema -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.GENERAL.THEME' | translate }}</label>
                    <select class="form-select">
                        <option value="light" selected>Claro</option>
                        <option value="dark">Escuro</option>
                        <option value="auto">Automático</option>
                    </select>
                    <small class="text-muted">{{ 'SETTINGS.GENERAL.THEME_HINT' | translate }}</small>
                </div>

                <!-- Items por página -->
                <div class="mb-0">
                    <label class="form-label fw-medium">{{ 'SETTINGS.GENERAL.ITEMS_PER_PAGE' | translate }}</label>
                    <select class="form-select">
                        <option value="10" selected>10 itens</option>
                        <option value="25">25 itens</option>
                        <option value="50">50 itens</option>
                        <option value="100">100 itens</option>
                    </select>
                    <small class="text-muted">{{ 'SETTINGS.GENERAL.ITEMS_PER_PAGE_HINT' | translate }}</small>
                </div>
            </div>
        </div>
    </div>

    <!-- Configurações de PGFN -->
    <div class="col-md-6 mb-3">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <i class="ti ti-file-invoice me-2"></i>
                    {{ 'SETTINGS.PGFN.TITLE' | translate }}
                </h5>
            </div>
            <div class="card-body">
                <!-- Auto-importação -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.PGFN.AUTO_IMPORT' | translate }}</label>
                    <select class="form-select">
                        <option value="disabled" selected>Desabilitado</option>
                        <option value="daily">Diário</option>
                        <option value="weekly">Semanal</option>
                        <option value="monthly">Mensal</option>
                    </select>
                    <small class="text-muted">{{ 'SETTINGS.PGFN.AUTO_IMPORT_HINT' | translate }}</small>
                </div>

                <!-- Desconto mínimo -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.PGFN.MIN_DISCOUNT' | translate }}</label>
                    <div class="input-group">
                        <input type="number" class="form-control" value="50" min="0" max="100">
                        <span class="input-group-text">%</span>
                    </div>
                    <small class="text-muted">{{ 'SETTINGS.PGFN.MIN_DISCOUNT_HINT' | translate }}</small>
                </div>

                <!-- Valor mínimo de dívida -->
                <div class="mb-0">
                    <label class="form-label fw-medium">{{ 'SETTINGS.PGFN.MIN_DEBT_VALUE' | translate }}</label>
                    <div class="input-group">
                        <span class="input-group-text">R$</span>
                        <input type="number" class="form-control" value="100000" min="0" step="10000">
                    </div>
                    <small class="text-muted">{{ 'SETTINGS.PGFN.MIN_DEBT_VALUE_HINT' | translate }}</small>
                </div>
            </div>
        </div>
    </div>

    <!-- Notificações -->
    <div class="col-md-6 mb-3">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <i class="ti ti-bell me-2"></i>
                    {{ 'SETTINGS.NOTIFICATIONS.TITLE' | translate }}
                </h5>
            </div>
            <div class="card-body">
                <!-- Email de novas dívidas -->
                <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="notifyNewDebts" checked>
                    <label class="form-check-label" for="notifyNewDebts">
                        {{ 'SETTINGS.NOTIFICATIONS.NEW_DEBTS' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.NOTIFICATIONS.NEW_DEBTS_HINT' | translate }}</small>
                    </div>
                </div>

                <!-- Email de vencimentos -->
                <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="notifyDueDates" checked>
                    <label class="form-check-label" for="notifyDueDates">
                        {{ 'SETTINGS.NOTIFICATIONS.DUE_DATES' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.NOTIFICATIONS.DUE_DATES_HINT' | translate }}</small>
                    </div>
                </div>

                <!-- Email de mudanças de status -->
                <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="notifyStatusChange">
                    <label class="form-check-label" for="notifyStatusChange">
                        {{ 'SETTINGS.NOTIFICATIONS.STATUS_CHANGE' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.NOTIFICATIONS.STATUS_CHANGE_HINT' | translate }}</small>
                    </div>
                </div>

                <!-- Notificações push -->
                <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="pushNotifications">
                    <label class="form-check-label" for="pushNotifications">
                        {{ 'SETTINGS.NOTIFICATIONS.PUSH' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.NOTIFICATIONS.PUSH_HINT' | translate }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- CRM / Kanban -->
    <div class="col-md-6 mb-3">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <i class="ti ti-layout-kanban me-2"></i>
                    {{ 'SETTINGS.CRM.TITLE' | translate }}
                </h5>
            </div>
            <div class="card-body">
                <!-- Auto-atribuição -->
                <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="autoAssign">
                    <label class="form-check-label" for="autoAssign">
                        {{ 'SETTINGS.CRM.AUTO_ASSIGN' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.CRM.AUTO_ASSIGN_HINT' | translate }}</small>
                    </div>
                </div>

                <!-- Dias para mover automaticamente -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.CRM.AUTO_MOVE_DAYS' | translate }}</label>
                    <select class="form-select">
                        <option value="0">Nunca</option>
                        <option value="7">7 dias</option>
                        <option value="15" selected>15 dias</option>
                        <option value="30">30 dias</option>
                    </select>
                    <small class="text-muted">{{ 'SETTINGS.CRM.AUTO_MOVE_DAYS_HINT' | translate }}</small>
                </div>

                <!-- Máximo de leads por usuário -->
                <div class="mb-0">
                    <label class="form-label fw-medium">{{ 'SETTINGS.CRM.MAX_LEADS' | translate }}</label>
                    <input type="number" class="form-control" value="10" min="1" max="50">
                    <small class="text-muted">{{ 'SETTINGS.CRM.MAX_LEADS_HINT' | translate }}</small>
                </div>
            </div>
        </div>
    </div>

    <!-- Integração / API -->
    <div class="col-md-6 mb-3">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <i class="ti ti-api me-2"></i>
                    {{ 'SETTINGS.INTEGRATION.TITLE' | translate }}
                </h5>
            </div>
            <div class="card-body">
                <!-- API Key -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.INTEGRATION.API_KEY' | translate }}</label>
                    <div class="input-group">
                        <input type="password" class="form-control" value="sk_live_123456789" readonly>
                        <button class="btn btn-outline-secondary" type="button">
                            <i class="ti ti-copy"></i>
                        </button>
                        <button class="btn btn-outline-secondary" type="button">
                            <i class="ti ti-refresh"></i>
                        </button>
                    </div>
                    <small class="text-muted">{{ 'SETTINGS.INTEGRATION.API_KEY_HINT' | translate }}</small>
                </div>

                <!-- Webhook URL -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.INTEGRATION.WEBHOOK' | translate }}</label>
                    <input type="url" class="form-control" placeholder="https://sua-api.com/webhook">
                    <small class="text-muted">{{ 'SETTINGS.INTEGRATION.WEBHOOK_HINT' | translate }}</small>
                </div>

                <!-- Integração com Minha Receita -->
                <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="minhaReceitaIntegration">
                    <label class="form-check-label" for="minhaReceitaIntegration">
                        {{ 'SETTINGS.INTEGRATION.MINHA_RECEITA' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.INTEGRATION.MINHA_RECEITA_HINT' | translate }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Segurança -->
    <div class="col-md-6 mb-3">
        <div class="card">
            <div class="card-header">
                <h5 class="mb-0">
                    <i class="ti ti-shield me-2"></i>
                    {{ 'SETTINGS.SECURITY.TITLE' | translate }}
                </h5>
            </div>
            <div class="card-body">
                <!-- Autenticação de 2 fatores -->
                <div class="form-check form-switch mb-3">
                    <input class="form-check-input" type="checkbox" id="twoFactor">
                    <label class="form-check-label" for="twoFactor">
                        {{ 'SETTINGS.SECURITY.TWO_FACTOR' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.SECURITY.TWO_FACTOR_HINT' | translate }}</small>
                    </div>
                </div>

                <!-- Tempo de sessão -->
                <div class="mb-3">
                    <label class="form-label fw-medium">{{ 'SETTINGS.SECURITY.SESSION_TIMEOUT' | translate }}</label>
                    <select class="form-select">
                        <option value="30">30 minutos</option>
                        <option value="60" selected>1 hora</option>
                        <option value="240">4 horas</option>
                        <option value="480">8 horas</option>
                    </select>
                    <small class="text-muted">{{ 'SETTINGS.SECURITY.SESSION_TIMEOUT_HINT' | translate }}</small>
                </div>

                <!-- Log de auditoria -->
                <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" id="auditLog" checked>
                    <label class="form-check-label" for="auditLog">
                        {{ 'SETTINGS.SECURITY.AUDIT_LOG' | translate }}
                    </label>
                    <div>
                        <small class="text-muted">{{ 'SETTINGS.SECURITY.AUDIT_LOG_HINT' | translate }}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Botões de ação -->
<div class="card">
    <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
                <i class="ti ti-info-circle me-1"></i>
                {{ 'SETTINGS.LAST_SAVED' | translate }}: Há 5 minutos
            </small>
            <div class="d-flex gap-2">
                <button class="btn btn-light">
                    <i class="ti ti-refresh me-1"></i>
                    {{ 'SETTINGS.RESET' | translate }}
                </button>
                <button class="btn btn-dark">
                    <i class="ti ti-device-floppy me-1"></i>
                    {{ 'SETTINGS.SAVE' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

